import React from 'react';
import {Result,Button} from 'antd';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function NotFoundPage(props){
	const {t} = useTranslation();
	return (
		<>
			<Result
				status="404"
				title="404"
				subTitle={t("Sorry, This page does not exist.")}
				extra={
					<Button type="primary">
						<Link to="/dashboard">{t("Back Home")}</Link>
					</Button>
				}
  		/>
		</>
	);
}

export default NotFoundPage;
